import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Row, Col, Form, Input, DatePicker, Select } from 'antd';
import moment from 'moment'
import { PAGE_SIZE_DEFAULT } from '../../../constants/appConstant';
import alertMessage from '../../../utils/alertMessage';
import auth from '../../../utils/auth';
const { RangePicker } = DatePicker;

@inject('webEDIStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef();
  componentDidMount() {
    const { webEDIStore } = this.props
    const token = auth.getToken();  //在请求头中获取token
    let strings
    let userInfo;
    if(token){
      strings = token.split("."); //截取token，获取载体
      userInfo = JSON.parse(decodeURIComponent(escape(window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/")))));
    }
    this.formRef.current.setFieldsValue({
      senderMail: userInfo?.HybridMail,
      receivedDate: [moment().startOf('day'), moment().endOf('day')],
    })
    webEDIStore.onSearchAction({
      "customerPoNo": "",
      "receivedDateBegin": moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      "receivedDateEnd": moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      "senderMail": userInfo?.HybridMail,
      "status": null,
      "templateType": null
    },1,PAGE_SIZE_DEFAULT)
    webEDIStore.onChangeSelectedRowKeys([],[])
  }
  handleSearch=()=>{
    const { webEDIStore } = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        customerPoNo: fieldsValue.customerPoNo,
        senderMail: fieldsValue.senderMail,
        status: fieldsValue.status,
        templateType: fieldsValue.templateType,
        receivedDateBegin: fieldsValue.receivedDate===null?undefined:!fieldsValue.receivedDate[0] ?'':moment(fieldsValue.receivedDate[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        receivedDateEnd: fieldsValue.receivedDate===null?undefined:!fieldsValue.receivedDate[1] ?'':moment(fieldsValue.receivedDate[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      }
      webEDIStore.onSearchAction(params,1,PAGE_SIZE_DEFAULT)
      webEDIStore.onChangeWebEDIListList([])
      webEDIStore.onChangeSelectedRowKeys([],[])
    }).catch(err => {
    })
  }
  handleResend=()=>{
    const { webEDIStore } = this.props
    const { selectedRowKeys } = webEDIStore
    // const params= []
    // selectedRows.filter(it=>it.status!==6).map(item=> {return params.push(item.requestId)})
    // if(params.length>0){
    //   alertMessage.error('所选数据状态必须为发送失败！')
    // }else {
    if(selectedRowKeys.length>0){
      webEDIStore.onResendAction({body:selectedRowKeys}).then(res=>{
        if (res.data.code === 0) {
          webEDIStore.onChangeSelectedRowKeys([],[])
        }
      })
    }else {
      alertMessage.error('Please select data！')
      return
    }
    // }
  }
  render() {
    const formItemLayout = {
      labelCol: { span: 10},
      wrapperCol: { span: 14 },
    }
    return (
      <>
        <Form ref={this.formRef} initialValues={{}}>
          <Row>
            <Col span={6}>
              <Form.Item name='senderMail' label='Sender Mail' {...formItemLayout}
                         rules={[{ message: 'Please enter Sender Mail without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                <Input placeholder="Please enter ..." allowClear />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name='customerPoNo' label='Customer PO NO' {...formItemLayout}
                         rules={[{ message: 'Please enter Customer PO NO without special characters.', pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/) }]}>
                <Input placeholder="Please enter ..." allowClear />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name='status' label='Status' {...formItemLayout}>
                <Select placeholder="Please select ..." onChange={this.onChange} allowClear>
                  <Select.Option key='1' value='1'>解析中</Select.Option>
                  <Select.Option key='2' value='2'>无附件</Select.Option>
                  <Select.Option key='3' value='3'>转换成功</Select.Option>
                  <Select.Option key='4' value='4'>转换失败</Select.Option>
                  <Select.Option key='5' value='5'>发送成功</Select.Option>
                  <Select.Option key='6' value='6'>发送失败</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name='templateType' label='Template Type' {...formItemLayout}>
                <Select placeholder="Please select ..." onChange={this.onChange} allowClear>
                  <Select.Option key='1' value='1'>简易订单</Select.Option>
                  <Select.Option key='2' value='2'>开市客订单</Select.Option>
                  <Select.Option key='3' value='3'>Braun订单</Select.Option>
                  <Select.Option key='4' value='4'>SK-II订单</Select.Option>
                  <Select.Option key='5' value='5'>SCW订单</Select.Option>
                  <Select.Option key='6' value='6'>Order Form订单</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12} style={{marginTop: 10}}>
              <Form.Item name='receivedDate' label='Received Date' htmlFor={null} labelCol={{span:5}} wrapperCol={{span:19}}>
                <RangePicker
                  format="YYYY-MM-DD"
                  style={{ width: "100%"}}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{textAlign: 'right', marginTop: 10}}>
              <Button style={{marginRight: 10}} onClick={this.handleSearch} type='primary'>Search</Button>
              <Button onClick={this.handleResend} type='primary'>Resend</Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  }
}

export default SearchForm;
